import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { WindowService } from '../../shared/services/window.service';
import { InfoItemTypes, InfoPanel, Item } from './info-panel.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss'],
})
export class InfoPanelComponent implements OnInit {
  @Input() config: InfoPanel;
  @Output() onItemHeaderClick = new EventEmitter();
  @Output() onItemClick = new EventEmitter();

  types = InfoItemTypes;

  constructor(private window: WindowService) {}

  ngOnInit() {
    const [config] = checkInputsForText([this.config]);

    this.config = config;
  }

  headerIconClicked(headerItem: Item) {
    if (headerItem.headerRoute) {
      const targetWindow = headerItem.openInNewTab ? '_blank' : '_self';

      this.window.nativeWindow.open(headerItem.headerRoute, targetWindow);
    } else {
      this.onItemHeaderClick.emit();
    }
  }

  fieldIconClicked(field) {
    field.route
      ? this.window.nativeWindow.open(field.route)
      : this.onItemClick.emit();
  }
}
